import { MAIN_TAB_DEFS } from '@/sections/poe/constants';

interface TabDescriptionProps {
  tabId: string;
}

/**
 * TabDescription - static description line for POE main tabs.
 *
 * Renders the tab's MAIN_TAB_DEFS description. The former markdown path
 * (rendering `definitionsFileValue` prose for an 'overview'/'information'
 * tab) is gone: evidence prose now lives in the Verification rail card
 * (usePOESections), and no POE tab has the id 'overview' — the sole call
 * site (POE.tsx) passes selectedTab.value drawn from MAIN_TAB_DEFS ids.
 */
export function TabDescription({ tabId }: TabDescriptionProps) {
  const tab = Object.values(MAIN_TAB_DEFS).find(tab => tab.id === tabId);
  return tab?.description || '';
}
